/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveScope } from '../models/ApiWaveScope';
import { HttpFile } from '../http/http';

export class ApiWaveVisibilityConfig {
    'scope': ApiWaveScope;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "scope",
            "baseName": "scope",
            "type": "ApiWaveScope",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveVisibilityConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

